import imageCompression from "browser-image-compression";
import { Field, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ImageCompressConfig } from "../../../../constants/ImageCompressConfig";
import { LOCALES } from "../../../../i18n/locales";
import { Input, TextArea } from "../../../common/control/InputField";
import * as actions from "../../redux/PromotionAction";

const initValues = {
  promotiontitle: "",
  promotioncontent: "",
  languagecode: "en",
};

export const PromotionCaptionForm = ({
  formikRef,
  promotionId,
  saveValues,
  fileInputRef,
  isResetField,
}) => {
  const intl = useIntl();
  const [file, setFile] = useState();
  const [imagePreview, setImagePreview] = useState();
  const [isUsedPreviousImage, setIsUsedPreviousImage] = useState(false);
  const isRemoveImgRef = useRef();

  const dispatch = useDispatch();
  const promotionState = useSelector(
    ({ promotion }) => promotion,
    shallowEqual
  );

  useEffect(() => {
    if (promotionId) {
      isResetField.current = true;
      dispatch(actions.fetchPromotionCaptionList({ promotionid: promotionId }));

      return () => dispatch(actions.clearCaptionList());
    }
  }, [promotionId]);

  const getCaptionByLanguage = (language) =>
    promotionState.promotionCaptionLists?.promotionCaptionLists.find(
      (caption) => caption.languagecode === language
    );

  useEffect(() => {
    if (promotionState.promotionCaptionLists && isResetField.current) {
      const caption = getCaptionByLanguage(LOCALES.ENGLISH);
      isRemoveImgRef.current =
        caption?.imageurl && caption?.imageurl !== "" ? false : undefined;
      if (fileInputRef.current) fileInputRef.current.value = "";
      setFile(undefined);
      setImagePreview(caption?.imageurl);
      formikRef.current.setValues({
        ...initValues,
        promotiontitle: caption?.promotiontitle,
        promotioncontent: caption?.promotioncontent,
      });
    }
  }, [promotionState.promotionCaptionLists]);

  const handleFileChange = (event) => {
    const handleFile = (file, fileName) => {
      const newFile = new File([file], fileName, {
        type: file.type,
      });
      isRemoveImgRef.current =
        isRemoveImgRef.current !== undefined && isRemoveImgRef.current !== null
          ? true
          : undefined;
      setImagePreview(URL.createObjectURL(newFile));
      setFile(newFile);
    };

    const fileName = event.currentTarget.files[0].name;
    imageCompression(event.currentTarget.files[0], ImageCompressConfig)
      .then((res) => handleFile(res, fileName))
      .catch(() => handleFile(event.currentTarget.files[0], fileName));
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initValues}
      enableReinitialize={true}
      onSubmit={(values) => {
        saveValues({
          ...values,
          image: file,
          isremove: isRemoveImgRef.current ? "true" : "false",
        });
      }}
    >
      {({
        values,
        handleSubmit,
        setFieldValue,
        touched,
        errors,
        setFieldError,
      }) => (
        <Form>
          <div className="mb-2">
            <label className="mb-2 text-input-label">
              {intl.formatMessage({ id: "language" })}
            </label>
            <select
              className="form-select"
              name="languagecode"
              onChange={(e) => {
                const caption = getCaptionByLanguage(e.target.value);
                setFieldValue("languagecode", e.target.value);
                setFieldValue("promotiontitle", caption?.promotiontitle ?? "");
                setFieldValue(
                  "promotioncontent",
                  caption?.promotioncontent ?? ""
                );
                isRemoveImgRef.current =
                  caption?.imageurl && caption?.imageurl !== ""
                    ? false
                    : undefined;
                setIsUsedPreviousImage(
                  (caption?.imageurl && caption?.imageurl !== "") || !file
                    ? false
                    : true
                );
                setImagePreview(
                  caption?.imageurl && caption?.imageurl !== ""
                    ? caption?.imageurl
                    : file
                    ? URL.createObjectURL(file)
                    : undefined
                );
                //Jacky want remain the image 18/5
                if (caption?.imageurl && caption?.imageurl !== "") {
                  fileInputRef.current.value = "";
                  setFile(undefined);
                }
              }}
              value={values.languagecode}
            >
              <option value={LOCALES.ENGLISH}>
                {intl.formatMessage({ id: "english" })}
              </option>
              <option value={LOCALES.CHINESE}>
                {intl.formatMessage({ id: "chinese" })}
              </option>
              <option value={LOCALES.MALAY}>
                {intl.formatMessage({ id: "malay" })}
              </option>
              <option value={LOCALES.INDO}>
                {intl.formatMessage({ id: "indo" })}
              </option>
            </select>
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label">
              {intl.formatMessage({ id: "promotionTitle" })}
            </label>
            <Field
              name="promotiontitle"
              component={Input}
              placeholder={intl.formatMessage({ id: "promotionTitle" })}
              autoComplete="off"
              type="text"
              inputClass="form-control"
              isAlphanumericOnly={false}
            />
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label">
              {intl.formatMessage({ id: "promotionContent" })}
            </label>
            <Field
              name="promotioncontent"
              component={TextArea}
              placeholder={intl.formatMessage({ id: "promotionContent" })}
              autoComplete="off"
              inputClass="form-control"
              isAlphanumericOnly={false}
              rows={10}
            />
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label">
              {intl.formatMessage({ id: "image" })}{" "}
              {intl.formatMessage({ id: "imageInfo" })}{" "}
              {isUsedPreviousImage && (
                <span className="text-warning" style={{ fontSize: "11px" }}>
                  * {intl.formatMessage({ id: "usedPreviousImage" })}
                </span>
              )}
            </label>
            {imagePreview && imagePreview !== "" && (
              <div
                style={{ maxHeight: "200px" }}
                className="mb-2 position-relative"
              >
                <img
                  src={imagePreview}
                  style={{ maxHeight: "200px" }}
                  onError={() => setImagePreview(undefined)}
                />

                <i
                  className="position-absolute bi bi-x-circle-fill text-danger fs-5 cursor-pointer"
                  onClick={() => {
                    setImagePreview(undefined);
                    setFile(undefined);
                    fileInputRef.current.value = "";
                    isRemoveImgRef.current =
                      isRemoveImgRef.current !== undefined &&
                      isRemoveImgRef.current !== null
                        ? true
                        : undefined;
                  }}
                  style={{ top: "0px", left: "5px" }}
                />
              </div>
            )}

            <input
              type="file"
              className="form-control text-font2"
              placeholder={intl.formatMessage({ id: "image" })}
              autoComplete="off"
              accept="image/*"
              onChange={handleFileChange}
              ref={fileInputRef}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};
